import {Box} from '@mui/material';
import {node, string} from 'prop-types';

import {getIconComponent} from '../../../../utils';

const CategoryAccordionIcon = ({iconName, color, customIcon}) => {
  const Icon = iconName ? getIconComponent(iconName) : null;

  return (
    <Box
      sx={{
        borderRadius: 3,
        py: 1.5,
        px: 1.8,
        background: `${color}30`
      }}
    >
      {customIcon || (
        <Icon
          sx={{
            fontSize: 18,
            color
          }}
        />
      )}
    </Box>
  );
};

CategoryAccordionIcon.propTypes = {
  color: string.isRequired,
  iconName: node,
  customIcon: node
};

export default CategoryAccordionIcon;
